import { render, staticRenderFns } from "./MDField.vue?vue&type=template&id=673739d5&"
import script from "./MDField.vue?vue&type=script&lang=js&"
export * from "./MDField.vue?vue&type=script&lang=js&"
import style0 from "./MDField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports